/** @jsx jsx */
import { jsx } from 'theme-ui';
import { CardIcon } from './CardIcon';
export var CardNumber = function (_a) {
    var className = _a.className, brand = _a.brand, last4 = _a.last4, short = _a.short;
    return (jsx("span", { className: className, sx: { whiteSpace: 'nowrap' } },
        jsx(CardIcon, { brand: brand, sx: { mr: 2 } }),
        !short && '•••• •••• •••• ',
        last4));
};
//# sourceMappingURL=CardNumber.js.map